import { RefreshCw, Trash2 } from "lucide-react";
import { useState } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useSamplesLaboratoryDeleteMutation } from "@/services/backend/samples/api/lab-api";
import { Laboratory } from "@/services/backend/samples/types/laboratory";

export function DeleteLabDialog({
  lab,
  onDelete,
}: {
  lab: Laboratory;
  onDelete?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [deleteLab, { error, isLoading, isSuccess, reset }] =
    useSamplesLaboratoryDeleteMutation();

  if (isSuccess) {
    reset();
    setOpen(false);
    onDelete?.();
  }

  const doDelete = () => {
    if (isLoading) return;
    deleteLab({ id: lab.id });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive">
          <Trash2 className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t(`Labor ${lab.name} wirklich löschen?`)}</DialogTitle>
          <DialogDescription>
            {t("Diese Aktion kann nicht rückgängig gemacht werden.")}
          </DialogDescription>
          <RTKQueryErrorAlert error={error} />
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">{t("Abbrechen")}</Button>
            </DialogClose>
            <Button
              variant="destructive"
              disabled={isLoading}
              onClick={doDelete}
            >
              {isLoading && <RefreshCw className="mr-2 size-4" />}
              {t("Löschen")}
            </Button>
          </DialogFooter>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
